<div class="content-box_module__333d9 content-box_lg__3v3a-">
  <header _ngcontent-bps-c143="" class="content-box_header__xPnGx clearfix">
    <div _ngcontent-bps-c143="" class="wil-float-left">
      <h4 _ngcontent-bps-c143="" class="content-box_title__1gBHS">
        <span _ngcontent-bps-c143="">All Applicants</span>
      </h4>
    </div>
  </header>

  <div class="content-box_body__3tSRB">
    <div class="jobsearch-typo-wrap">
      <div class="jobsearch-allaplicants-holder">

        <div class="select-appsjob-con">
          <div class="allapps-selctcounts-holdr">
            <div class="allapps-job-label">
              <h2>Filter by Job</h2>
            </div>
            <div class="allapps-jobselct-con" style="display: inline-block; position: relative;">
              <mat-form-field appearance="outline">
                <mat-label>Job Title</mat-label>
                <input matInput [(ngModel)]="searchString">
              </mat-form-field>
            </div>
          </div>
          <div class="overall-appcreds-con">
            <ul>
              <li><span class="tot-apps">Total Applicants </span>
                <div class="applicnt-count-box tot-apps"> <a class="overall-site-aplicnts">{{totalApplications}}</a>
                </div>
              </li>
              <li><span class="sh-apps">Shortlisted Applicants </span>
                <div class="applicnt-count-box sh-apps"> <a
                    class="overall-site-shaplicnts">{{shortlistedApplications}}</a></div>
              </li>
              <li><span class="rej-apps">Rejected Applicants </span>
                <div class="applicnt-count-box rej-apps"> <a
                    class="overall-site-rejaplicnts">{{rejectedApplications}}</a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="jobsearch-all-aplicantslst">
          <ng-container *ngFor="let applicationGroup of jobApplications">
            <div *ngIf="applicationGroup.job_title.toLowerCase().includes(searchString.toLowerCase())"
              class="sjob-aplicants-list">
              <div class="thjob-title">
                <h2>{{applicationGroup.job_title}}</h2>
                <div class="total-appcreds-con">
                  <ul>
                    <li>
                      <div class="applicnt-count-box tot-apps"><span>Total Applicants:
                        </span>{{applicationGroup.totalApplications()}}</div>
                    </li>
                    <li>
                      <div class="applicnt-count-box sh-apps"><span>Shortlisted Applicants:
                        </span>{{applicationGroup.shortlistedApplications()}}
                      </div>
                    </li>
                    <li>
                      <div class="applicnt-count-box rej-apps"><span>Rejected Applicants:
                        </span>{{applicationGroup.rejectedApplications()}}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="jobsearch-applied-jobs">
                <ul id="job-apps-list17361" class="jobsearch-row">
                  <li *ngFor="let application of applicationGroup.applications" class="jobsearch-column-12">
                    <div class="jobsearch-applied-jobs-wrap">

                      <a class="jobsearch-applied-jobs-thumb" (click)="goToUserDetails(application)">
                        <img [src]="getUserProfilePicture(application.user)">
                      </a>
                      <div class="jobsearch-applied-jobs-text">
                        <div class="jobsearch-applied-jobs-left">
                          <small class="profile-view"
                            [ngClass]="application.viewed ? 'color-success' : 'color-danger'">{{application.viewed ?
                            '(Viewed)' :
                            '(Unviewed)'}}</small>
                          <small *ngIf="application.shortlisted" class="profile-view color-success">
                            (Shortlisted)</small>
                          <small *ngIf="application.rejected" class="profile-view color-danger"> (Rejected)</small>
                          <h2 class="jobsearch-pst-title">
                            <a (click)="goToUserDetails(application)">{{application.user.display_name}}</a>
                          </h2>
                          <ul>
                            <li><i class="jobsearch-icon jobsearch-calendar"></i> Applied at: {{application.created_at |
                              date:'MMM d, y h:mm a'}}</li>
                          </ul>
                        </div>
                        <div class="jobsearch-applied-job-btns">
                          <ul>
                            <li>
                              <a (click)="goToUserDetails(application)" class="preview-candidate-profile"><i
                                  class="fa fa-eye"></i>
                                Preview</a>
                            </li>
                            <li>
                              <div class="candidate-more-acts-con">
                                <a class="more-actions" (click)="dropdown.style.display = 'block'"
                                  (clickOutside)="dropdown.style.display = 'none'">Actions
                                  <i class="fa fa-angle-down"></i></a>
                                <ul #dropdown>
                                  <li><a class="jobsearch-modelcvrltr-btn-580809"
                                      (click)="viewCoverLetter(application)">View
                                      Cover Letter</a></li>
                                  <li>
                                    <a class="jobsearch-modelemail-btn-580809"
                                      (click)="downloadCV(application)">Download CV</a>
                                  </li>
                                  <li>
                                    <a class="jobsearch-modelemail-btn-580809" (click)="sendEmail(application)">Email to
                                      Candidate</a>
                                  </li>
                                  <li>
                                    <a (click)="sendMessage(application)" class="jobsearch-modelemail-btn-580809">Send
                                      Message</a>
                                  </li>
                                  <li *ngIf="!application.rejected">
                                    <a class="shortlist-cand-to-intrview ajax-enable"
                                      (click)="shortlistApplication(application)">{{application.shortlisted ?
                                      'Shortlisted' :
                                      'Shortlist for Interview'}}</a>
                                  </li>
                                  <li>
                                    <a class="reject-cand-to-intrview ajax-enable"
                                      (click)="rejectApplication(application)">{{application.rejected ? 'Rejected' :
                                      'Reject'}}</a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

  </div>
</div>
